import PrivacyControlsModule from './PrivacyControlsModule';

export default PrivacyControlsModule;
